var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 20c5.523 0 10-4.477 10-10S19.523 0 14 0 4 4.477 4 10s4.477 10 10 10z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ACF0",
    d: "M17.403 8.612h-.348V7.223c0-.364-.072-.726-.211-1.063-.14-.337-.344-.643-.602-.901s-.565-.463-.902-.602c-.337-.14-.698-.212-1.063-.212-.364 0-.726.072-1.063.212-.337.14-.643.344-.901.602s-.463.564-.602.901c-.14.337-.212.699-.212 1.063v1.39h-.346c-.276 0-.54.11-.736.304-.195.196-.305.46-.306.736v4.861c0 .277.11.542.306.737.195.195.46.305.736.305h6.25c.277 0 .542-.11.737-.305.195-.195.305-.46.305-.737v-4.86c0-.277-.11-.541-.305-.737-.196-.195-.46-.304-.737-.305zm-4.977-1.389c.022-.475.227-.924.572-1.253.344-.33.802-.513 1.278-.513.477 0 .935.184 1.28.513.344.329.548.778.57 1.253v1.39h-3.7v-1.39zm2.315 4.964v1.058c0 .123-.048.24-.135.328-.087.086-.205.135-.328.135-.123 0-.24-.049-.327-.135-.087-.087-.136-.205-.136-.328v-1.058c-.176-.102-.314-.259-.392-.447-.078-.189-.092-.397-.04-.594.054-.197.17-.371.332-.495.161-.124.36-.192.563-.192.204 0 .402.068.564.192.162.124.278.298.33.495.053.197.04.405-.038.594-.078.188-.216.345-.393.447z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocked);
export default __webpack_public_path__ + "static/media/ic-locked.7e96a9f330956230654ec1897d4125b0.svg";
export { ForwardRef as ReactComponent };